<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fill-rule="evenodd">
      <g fill="#FFF">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M2.222 8.333L4.444 8.333 4.444 6.667 2.222 6.667zM5.556 8.333L7.778 8.333 7.778 6.667 5.556 6.667zM8.889 8.333L11.111 8.333 11.111 6.667 8.889 6.667zM2.222 11.111L4.444 11.111 4.444 9.444 2.222 9.444zM5.556 11.111L7.778 11.111 7.778 9.444 5.556 9.444zM8.889 11.111L11.111 11.111 11.111 9.444 8.889 9.444z"
                  transform="translate(-791 -549) translate(128 540) translate(647) translate(16 9) translate(1.333 1.333)"
                />
                <path
                  d="M1.111 4.444V2.222h1.667v1.111h1.11v-1.11h5.556v1.11h1.111v-1.11h1.667v2.221H1.112zm0 7.778h11.111V5.556H1.112v6.666zM12.222 1.111h-1.666V0H9.444v1.111H3.888V0H2.778v1.111H1.11c-.61 0-1.111.5-1.111 1.111v11.111h13.333V2.223c0-.612-.5-1.112-1.11-1.112z"
                  transform="translate(-791 -549) translate(128 540) translate(647) translate(16 9) translate(1.333 1.333)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>